import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_250: DocMigration = {
  maxSchemaVersion: "0.0.250",
  description: "",
  apply(json: any) {
    for (const caseworkId in json.casework) {
      const casework = json.casework[caseworkId];

      // assign type to a few props that didn't have a width mode
      if (casework.type === "WALL") {
        casework.type = "DYNAMIC";
      }
      if (casework.type === "FIXED") {
        casework.param = casework.placementStart.param;
        casework.paramNormalized = casework.placementStart.paramNormalized;
        delete casework.placementStart;
      }
    }
    return json;
  },
};

export default migration_0_0_250;
